/* eslint-disable import/prefer-default-export */
import {
  STATE_AVAILABLE,
  STATE_PARTIALLY_AVAILABLE,
  STATE_SOLD_OUT,
} from './calendarStateDeterminer';

function findNextAvailable(inventoryList) {
  const inventoryItem = inventoryList.find((item) => item.inventory?.reservation === STATE_AVAILABLE);
  return inventoryItem ? inventoryItem.date : null;
}

function getAriaLabel(status, ariaString) {
  let label;

  if (status === STATE_AVAILABLE || status === STATE_PARTIALLY_AVAILABLE) {
    label = `Show booking times for ${ariaString}`;
  } else if (status === STATE_SOLD_OUT) {
    label = `${ariaString} is sold out.`;
  }

  // Potentially returning undefined is key here.
  // 'date.ariaLabel' ends up being bound to ng-attr-aria-label,
  // which will only correctly NOT apply the attribute if the value is undefined. (null does not work)
  return label;
}

function getDateRange(startDate) {
  const now = moment();
  const dateRange = {};
  let tempDate = moment(startDate);

  const oneYearFromToday = moment().add(1, 'year');

  for (let i = 0; i < 365; i += 1) {
    const dateString = tempDate.format('YYYY-MM-DD');

    let status = 'no-data';
    if (tempDate.isBefore(now, 'days') || tempDate.isAfter(moment(oneYearFromToday), 'days')) {
      status = 'outside-window';
    }

    dateRange[dateString] = status;

    tempDate = tempDate.add(1, 'days');
  }
  return dateRange;
}

function getAnalyticsInventory(inventoryByDayItem = {}) {
  let inventory;
  const { event, reservation, 'walk-in': walkIn } = inventoryByDayItem;

  if (event === 'closed' && reservation === 'closed' && walkIn === 'closed') {
    inventory = 'closed';
  } else if (event === 'available') {
    if (reservation === 'available' || walkIn === 'available') {
      inventory = 'available with event';
    } else {
      inventory = 'sold out with event';
    }
  } else if (reservation === 'available' || walkIn === 'available') {
    inventory = 'available';
  } else {
    inventory = 'sold out';
  }

  return inventory;
}

function getVisibleSlotCount(reservations = []) {
  if (!Array.isArray(reservations)) {
    return 0;
  }
  return reservations.reduce((total, serviceType) => (
    total + (Array.isArray(serviceType?.available) ? serviceType.available.length : 0)
  ), 0);
}

export default {
  findNextAvailable,
  getAnalyticsInventory,
  getAriaLabel,
  getDateRange,
  getVisibleSlotCount,
};
